<p *ngIf="loading">{{ 'Order Loading' | translate }}..</p>
<p *ngIf="!loading">{{ 'Order Id' | translate }}: {{orderId}}</p>
